<template>
<div class="control-group hide-small hide-tiny" style="cursor: pointer;">
    <label>{{text}}</label>
    <div class="control" v-on:click="Change()">
        <div class="btn-group btn-group-toggle">
            <label data-trackerlink="PESQUISA|FILTROS|LISTINGVIEW" class="btn" :class="listClass">
                <i class="fas fa-th-list"></i>
            </label>
            <label data-trackerlink="PESQUISA|FILTROS|GRIDVIEW" class="btn" :class="gridClass">
                <i class="fas fa-th"></i>
            </label>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:{
        text: {
            type: String,
            default: "Mostrar"
        },
        propIsGrid: {
            type:Boolean,
            default: true
        },
        propIsGridInitialValue: {
            type:Boolean,
            default: true
        }
    },
    data(){
        return {
        }
    },
    methods: {
        Change: function(){
            this.propIsGrid = !this.propIsGrid;
            this.$emit('changed', {isGrid:this.propIsGrid});
        }
    },
    computed:{
        listClass: function(){
            return this.propIsGrid?'':'active';
        },
        gridClass: function(){
            return this.propIsGrid?'active':'';
        }
    },
    mounted(){
        this.propIsGrid = this.propIsGridInitialValue;
    }
}
</script>